/**
 * Helper to bind select elements to EasyCurrency.
 */
export default class SelectHelper {

    /**
     * Construct a new instance of the helper.
     * @param {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} easyCurrency
     */
    constructor(easyCurrency) {
        /** @type {src/plugins/easycurrency/EasyCurrency.js~EasyCurrency} */
        this._easyCurrency = easyCurrency;
    }


    /**
     * Bind a input element with EasyCurrency.
     * @param {DOMNode}	element
     */
    link(element) {
        element.addEventListener('change', (e) => {
            this._easyCurrency.setActiveCurrency(element.value);
        });

        this._easyCurrency.on('currencyChanged', (e) => {
            var newCurrency = e.data;
            element.value = newCurrency;
        });

        element.value = this._easyCurrency.getActiveCurrency();
    }
}



// WEBPACK FOOTER //
// ./src/plugins/easycurrency/helpers/SelectHelper.js